import { useProductSummaryImage } from '../hooks/useProductSummaryImage';

type DiscountContainerProps = { children: React.ReactNode };

const DiscountContainer = ({ children }: DiscountContainerProps) => {
	const { componentId } = useProductSummaryImage();

	return (
		<div data-selection={componentId} className={`vtex-store-components-3-x-discountContainer relative dib`}>
			{children}
		</div>
	);
};

export default DiscountContainer;
